<template>
  <div class="clue-pool">
    <el-divider content-position="left">公海池</el-divider>
    <el-collapse @change="handleChangeHeight" v-model="activeOpen">
      <el-collapse-item title="高级筛选" name="1">
        <div class="changeHeight m-tabs-content">
          <el-row type="flex">
            <el-col :span="2" v-if="false" class="tr m-label text_right">群聊ID</el-col>
            <el-col :span="4" v-if="false">
              <el-input
                @change="groupInput"
                v-model="highSearch.group_chat_id"
                size="mini"
                placeholder="输入群聊ID"
              />
            </el-col>
            <el-col :span="2" class="tr m-label text_right">IM人员</el-col>
            <el-col :span="4">
              <el-select
                :filterable="true"
                multiple
                collapse-tags
                v-model="highSearch.im_name"
                placeholder="请选择IM人员"
                size="mini"
                clearable
              >
                <el-option
                  v-for="(item, index) in ConversionPeople"
                  :key="index"
                  :label="item.username"
                  :value="item.id"
                >
                </el-option>
              </el-select>
            </el-col>
            <el-col :span="2" :offset="3" class="tr m-label text_right">选择园区</el-col>
            <el-col :span="4">
              <el-select
                multiple
                collapse-tags
                v-model="highSearch.garden"
                placeholder="请选择园区"
                @change="selectType"
                size="mini"
                clearable
              >
                <el-option
                  v-for="item in options4"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                >
                </el-option>
              </el-select>
            </el-col>
            <el-col :span="2" :offset="3" class="tr m-label text_right">录入时间</el-col>
            <el-col :span="4">
              <div class="block">
                <el-date-picker
                  v-model="value1"
                  type="daterange"
                  range-separator="至"
                  size="mini"
                  format="yyyy 年 MM 月 dd 日"
                  value-format="yyyy-MM-dd"
                  @change="pickerDataChange"
                  start-placeholder="开始日期"
                  end-placeholder="结束日期"
                  :picker-options="pickerOptions"
                >
                </el-date-picker>
              </div>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="2" class="tr m-label text_right">最近联系时间</el-col>
            <el-col :span="4">
              <div>
                <el-date-picker
                  v-model="highSearch.communicat_at"
                  type="daterange"
                  range-separator="至"
                  size="mini"
                  format="yyyy 年 MM 月 dd 日"
                  value-format="yyyy-MM-dd"
                  @change="pickerDataChangeRecently"
                  start-placeholder="开始日期"
                  end-placeholder="结束日期"
                >
                </el-date-picker>
              </div>
            </el-col>
            <el-col :span="2" :offset="3" class="tr m-label text_right">沟通次数</el-col>
            <el-col :span="4">
              <el-input
                @change="communicatTimes"
                v-model="highSearch.communicat_times"
                size="mini"
                placeholder="输入沟通次数(1 2 3...)"
              />
            </el-col>
            <el-col :span="2" :offset="3" class="tr m-label text_right">咨询分类</el-col>
            <el-col :span="4">
              <el-select
                :filterable="true"
                v-model="highSearch.refer_cate"
                placeholder="请选择"
                :size="inputSize"
                clearable
              >
                <el-option
                  v-for="item in serverTypes"
                  :key="item.server_id"
                  :label="item.server_name"
                  :value="item.server_id"
                >
                </el-option>
              </el-select>
            </el-col>
          </el-row>
          <el-row v-if="false">
            <el-col v-if="false" :span="2" class="tr m-label text_right">所属省市</el-col>
            <el-col v-if="false" :span="4">
              <el-cascader
                ref="cascaderAddr"
                style="width: 100%"
                v-model="value3"
                :props="optionProps"
                :options="options"
                size="mini"
                @change="handleChangeSearch"
              ></el-cascader>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="24" class="tr">
              <el-button type="primary" size="mini" @click="handleSearch">查询</el-button>
              <el-button type="danger" size="mini" @click="handleCloseSearch"
                >清除</el-button
              >
            </el-col>
          </el-row>
        </div>
      </el-collapse-item>
    </el-collapse>
    <el-row class="mb-10">
      <el-col :span="7" style="display: flex">
        <div class="level count_style">
          <span class="count">等级：</span>
          <img :src="img" alt="" />
          <span class="count">{{ vipName }}</span>
          <i class="el-icon-question" @click="dialogVisible = true"></i>
        </div>
        <div class="level_num count_style">
          <span style="padding-left: 0.4rem">线索总数：{{ count }}</span>
          <span style="padding-left: 0.4rem" class="count"
            >已领取：{{ vipData.user_thread_row }}/{{ vipData.store_space }}</span
          >
        </div>
      </el-col>
      <el-col :span="5" v-if="pageNodes.indexOf('导出') !== -1">
        <div>
          <el-date-picker
            v-model="values"
            type="daterange"
            range-separator="至"
            size="mini"
            format="yyyy 年 MM 月 dd 日"
            value-format="yyyy-MM-dd"
            @change="pickerDataChange2"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            :picker-options="pickerOptionsExport"
          >
          </el-date-picker>
        </div>
      </el-col>
      <el-col :span="6" v-if="pageNodes.indexOf('导出') !== -1">
        <el-select
          v-model="value2"
          multiple
          collapse-tags
          size="mini"
          @change="selectExport"
          style="margin-left: 20px"
          placeholder="请选择导出条件"
        >
          <el-option
            v-for="item in options2"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          >
          </el-option>
        </el-select>
      </el-col>
      <el-col :span="6" class="tr">
        <el-button
          v-if="pageNodes.indexOf('分配线索') !== -1"
          type="primary"
          size="mini"
          @click="handleAddAllot"
          >分配线索</el-button
        >
        <el-button
          v-if="pageNodes.indexOf('录入线索') !== -1"
          type="primary"
          size="mini"
          @click="handleAddOpen"
          >录入线索</el-button
        >
        <el-button
          v-if="pageNodes.indexOf('导入') !== -1"
          type="primary"
          @click="dialogVisible3 = true"
          plain
          size="mini"
          >导入</el-button
        >
        <el-button
          v-if="pageNodes.indexOf('导出') !== -1"
          style="margin-left: 0.1rem"
          type="primary"
          plain
          size="mini"
          @click="handleExport"
          >导出</el-button
        >
      </el-col>
    </el-row>
    <el-row class="mb-10">
      <!-- v-if="pageNodes.indexOf('搜索') !== -1" -->
      <el-col :span="12">
        <el-button
          style="margin-left: 0.1rem"
          type="primary"
          size="mini"
          @click="downloadHandleImport"
          >下载导入模板</el-button
        >
      </el-col>
      <el-col
        :span="12"
        v-if="pageNodes.indexOf('搜索') !== -1"
        class="search_position tr"
      >
        <el-input
          prefix-icon="el-icon-search search"
          style="width: 40%"
          v-model="search"
          size="mini"
          placeholder="输入客户手机号或微信号搜索"
          @input="getDetail"
        />
      </el-col>
    </el-row>
    <!--    border-->
    <!-- pageData -->
    <el-table
      :data="CluesPool"
      size="medium"
      style="width: 100%"
      @selection-change="handleSelectionChange"
    >
      <el-table-column
        v-if="pageNodes.indexOf('分配线索') !== -1"
        type="selection"
        width="55"
      ></el-table-column>
      <el-table-column fixed label="线索编码" width="140" prop="thread_id">
        <template slot-scope="scope">
          <span
            style="margin-right: 0.1rem; cursor: pointer"
            @click="copyUrl(scope.row.tag_code)"
            >{{ scope.row.tag_code }}</span
          >
        </template>
      </el-table-column>
      <el-table-column class="el-status" fixed label="线索状态" prop="status" width="120">
        <template slot-scope="scope">
          <span class="el-position"
            ><span
              class="dot"
              :style="{
                background:
                  scope.row.status === 0
                    ? '#88D023'
                    : '' || scope.row.status === 1
                    ? '#88D023'
                    : '' || scope.row.status === 2
                    ? '#CCCCCC'
                    : '' || scope.row.status === 3
                    ? '#D02323'
                    : '',
              }"
            >
            </span>
            {{
              scope.row.status == 0
                ? "未认领"
                : "" || scope.row.status == 1
                ? "跟踪中"
                : "" || scope.row.status == 2
                ? "已成交"
                : "" || scope.row.status == 3
                ? "无法联系"
                : ""
            }}
          </span>
        </template>
      </el-table-column>
      <el-table-column fixed label="沟通次数" width="100" prop="communicat_times">
        <template slot-scope="scope">
          <span
            style="margin-right: 0.1rem; cursor: pointer"
            @click="copyUrl(scope.row.communicat_times)"
            >{{ scope.row.communicat_times }}</span
          >
        </template>
      </el-table-column>
      <el-table-column class="omit" width="110" label="录入时间" prop="created_at">
        <template slot-scope="scope">
          <el-tooltip :content="scope.row.created_at" placement="top">
            <span class="count_style" style="display: inherit">{{
              scope.row.created_at
            }}</span>
          </el-tooltip>
        </template>
      </el-table-column>
      <el-table-column class="omit" width="110" label="客户手机" prop="custom_phone">
        <template slot-scope="scope">
          <span class="count_style" style="display: inherit">{{
            scope.row.custom_phone2
          }}</span>
        </template>
      </el-table-column>
      <el-table-column class="omit" width="110" label="微信号" prop="wechat_account">
        <template slot-scope="scope">
          <span class="count_style" style="display: inherit">{{
            scope.row.wechat_account2
          }}</span>
        </template>
      </el-table-column>
      <el-table-column
        v-for="(item, index) in col"
        :key="index"
        :prop="item.prop"
        :label="item.label"
        :width="tableColumn(item.prop)"
      >
        <template slot-scope="scope">
          <el-tooltip
            v-if="item.prop === 'page_title'"
            :content="scope.row[item.prop] + ''"
            placement="top"
          >
            <span class="count_style" style="display: inherit">{{
              scope.row[item.prop]
            }}</span>
          </el-tooltip>
          <el-tooltip v-else :content="scope.row[item.prop]" placement="top">
            <span class="count_style" style="display: inherit">{{
              scope.row[item.prop]
            }}</span>
          </el-tooltip>
        </template>
      </el-table-column>
      <el-table-column label="咨询关键内容" width="180" prop="refer_content">
        <template slot-scope="scope">
          <el-tooltip :content="scope.row.refer_content" placement="top">
            <span class="count_style" style="display: inherit">{{
              scope.row.refer_content
            }}</span>
          </el-tooltip>
        </template>
      </el-table-column>
      <el-table-column fixed="right" label="操作" width="60">
        <template slot-scope="scope">
          <el-tooltip class="item" effect="dark" content="领取线索" placement="top">
            <el-button
              type="primary"
              size="mini"
              icon="el-icon-plus"
              @click="handleEditOpen(scope.$index, scope.row.thread_id)"
              circle
            ></el-button>
          </el-tooltip>
        </template>
      </el-table-column>
    </el-table>
    <el-pagination
      background
      class="tr mt-10"
      layout="sizes, total, prev, pager, next, jumper"
      :hide-on-single-page="false"
      :current-page="pageOption.currentPage"
      :page-sizes="[10, 25, 50, 100]"
      :page-size="pageOption.pageSize"
      :total="pageOption.total"
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
    >
    </el-pagination>
    <el-drawer
      title="线索录入"
      :visible.sync="addDrawer"
      direction="rtl"
      :before-close="handleAddDrawerBeforeClose"
      size="40%"
    >
      <div class="m-tabs-content">
        <div class="tabs_line">
          <div class="lines"></div>
          <h3 class="tabs-title">线索信息</h3>
        </div>
        <el-divider></el-divider>
        <el-row>
          <el-col :span="6" class="m-label">选择园区：</el-col>
          <el-col :span="10">
            <el-select
              v-model="addForm.garden"
              placeholder="请选择"
              :size="inputSize"
              clearable
            >
              <el-option :value="1" label="上海园区"></el-option>
              <el-option :value="2" label="南京园区"></el-option>
              <el-option :value="3" label="徐州园区"></el-option>
              <el-option :value="4" label="其他园区"></el-option>
            </el-select>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="6" class="m-label">线索状态：</el-col>
          <el-col :span="10">
            <el-select
              v-model="addForm.status"
              @change="selectStatus"
              placeholder="请选择"
              :size="inputSize"
              clearable
            >
              <el-option :value="1" label="跟踪中"></el-option>
              <el-option :value="4" label="成单待确认"></el-option>
              <el-option :value="3" label="无法联系"></el-option>
              <el-option :value="2" label="已成交"></el-option>
            </el-select>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="6" class="m-label">客户来源：</el-col>
          <el-col :span="10">
            <el-select
              :filterable="true"
              v-model="addForm.customer_source"
              placeholder="请选择"
              :size="inputSize"
              clearable
            >
              <el-option
                v-for="item in customerSource"
                :key="item.source_id"
                :label="item.source_name"
                :value="item.source_id"
              >
              </el-option>
            </el-select>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="6" class="m-label">客户姓名：</el-col>
          <el-col :span="10"
            ><el-input
              v-model="addForm.custom_name"
              :size="inputSize"
              clearable
            ></el-input
          ></el-col>
        </el-row>
        <el-row>
          <el-col :span="6" class="m-label">客户手机：</el-col>
          <el-col :span="10"
            ><el-input
              maxlength="11"
              v-model="addForm.custom_phone"
              :size="inputSize"
              clearable
            ></el-input
          ></el-col>
        </el-row>
        <el-row>
          <el-col :span="6" class="m-label">微信号：</el-col>
          <el-col :span="10"
            ><el-input
              v-model="addForm.wechat_account"
              :size="inputSize"
              clearable
            ></el-input
          ></el-col>
        </el-row>
        <el-row>
          <el-col :span="6" class="m-label">所属省市：</el-col>
          <el-col :span="10">
            <el-cascader
              ref="cascaderAddr"
              style="width: 100%"
              v-model="value"
              :props="optionProps"
              :options="options"
              :size="inputSize"
              @change="handleChange"
            ></el-cascader>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="6" class="m-label">群聊ID：</el-col>
          <el-col :span="10"
            ><el-input
              v-model="addForm.group_chat_id"
              :size="inputSize"
              clearable
            ></el-input
          ></el-col>
        </el-row>
        <el-row>
          <el-col :span="6" class="m-label">页面标题：</el-col>
          <el-col :span="10"
            ><el-input v-model="addForm.page_title" :size="inputSize" clearable></el-input
          ></el-col>
        </el-row>
        <el-row v-show="addForm.status === 4">
          <el-col :span="6" class="m-label">转化人：</el-col>
          <el-col :span="10">
            <el-select
              :filterable="true"
              v-model="addForm.uid"
              placeholder="请选择"
              :size="inputSize"
              clearable
            >
              <el-option
                v-for="(item, index) in ConversionPeople"
                :key="index"
                :label="item.username"
                :value="item.id"
              >
              </el-option>
            </el-select>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="6" class="m-label">咨询分类：</el-col>
          <el-col :span="10">
            <el-select
              :filterable="true"
              v-model="addForm.refer_cate"
              placeholder="请选择"
              :size="inputSize"
              clearable
            >
              <el-option
                v-for="item in serverTypes"
                :key="item.server_id"
                :label="item.server_name"
                :value="item.server_id"
              >
              </el-option>
            </el-select>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="6" class="m-label">是否分配线索：</el-col>
          <el-col :span="10" class="m-label">
            <el-switch
              v-model="switchValue"
              :width="40"
              @change="switchChange"
              active-text=""
            >
            </el-switch>
          </el-col>
        </el-row>
        <el-row v-show="addForm.type">
          <el-col :span="6" class="tr m-label text_right">公司分配:</el-col>
          <el-col :span="10">
            <el-select
              :filterable="true"
              v-model="addForm.uid"
              placeholder="请选择分配人员"
              size="mini"
              clearable
            >
              <el-option
                v-for="(item, index) in ConversionPeople"
                :key="index"
                :label="item.username"
                :value="item.id"
              >
              </el-option>
            </el-select>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="6" class="m-label">咨询关键内容：</el-col>
          <el-col :span="18">
            <el-input
              style="min-height: 1rem"
              :autosize="textareaSize"
              type="textarea"
              v-model="addForm.refer_content"
              size="mini"
              clearable
            ></el-input>
          </el-col>
        </el-row>
      </div>
      <el-row class="bottom-btn">
        <el-button @click="handleSave" size="mini" type="primary">保存</el-button>
      </el-row>
    </el-drawer>
    <el-dialog :visible.sync="dialogVisible" class="el_dialogs" width="60%">
      <div class="box_title">
        <span>等级规则介绍</span>
        <i style="color: #4c87fc" class="el-icon-question"></i>
      </div>
      <div class="dialog_box">
        <p class="box_p">每周日晚上凌晨自动计算一次。</p>
        <p class="box_p">所在等级匹配相应仓位，</p>
        <p class="box_p">
          若是被降级，保持现有的线索，不能再领取，不能超过当前仓位，只能通过放弃到当前等级对应的仓位以下才能领取新线索。
        </p>
        <img src="../../assets/image/level.png" />
      </div>
      <span slot="footer" class="dialog-footer"> </span>
    </el-dialog>
    <el-dialog title="选择分配人员" :visible.sync="dialogVisible2" width="25%">
      <div class="contents" style="margin-bottom: 0">
        <el-select
          style="width: 100%"
          :filterable="true"
          v-model="allotData.uid"
          placeholder="请选择分配人员"
          size="mini"
          clearable
        >
          <el-option
            v-for="(item, index) in ConversionPeople"
            :key="index"
            :label="item.username"
            :value="item.id"
          >
          </el-option>
        </el-select>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button size="mini" @click="HandleDialogVisibleClose()">取 消</el-button>
        <el-button size="mini" type="primary" @click="HandleDialogVisible()"
          >确 定</el-button
        >
      </span>
    </el-dialog>
    <el-dialog title="导入线索" :visible.sync="dialogVisible3" width="25%">
      <div class="contents" style="margin-bottom: 0">
        <el-select
          style="width: 100%"
          @change="selectCluesType"
          v-model="clues_type"
          placeholder="请选择线索类型"
          size="mini"
          clearable
        >
          <el-option :value="1" label="IM套电"></el-option>
          <el-option :value="2" label="下单未支付"></el-option>
          <el-option :value="3" label="仅点快捷回复"></el-option>
          <el-option :value="4" label="仅IM咨询"></el-option>
        </el-select>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button size="mini" @click="HandleDialogVisibleClose2">取 消</el-button>
        <el-button
          v-show="uploadStatus === false"
          type="primary"
          size="mini"
          @click="HandleDialogVisible2"
          >点击上传</el-button
        >
        <el-upload
          v-show="uploadStatus === true"
          style="display: inline-block; margin-left: 0.2rem"
          :action="actionHost + '/api/tm_thread/excel'"
          :headers="uploadHeader"
          accept=".xls,.xlsx"
          :show-file-list="false"
          :data="{ input_type: clues_type }"
          :before-upload="beforeAvatarUpload"
          :on-success="handleImport"
        >
          <el-button size="mini" type="primary">点击上传</el-button>
        </el-upload>
      </span>
    </el-dialog>
    <el-dialog title="导入线索详情" :visible.sync="dialogVisible4" width="25%">
      <div class="export_clues">
        <span
          >您已成功导入<span style="color: #4c87fc"> {{ existPhone.success_count }} </span
          >条线索</span
        >
      </div>
      <p class="hint">以下手机号已存在线索库 {{ existPhoneCount + " 个" }}</p>
      <div class="show_phone">
        <div class="existPhone">
          <span
            class="phone_span"
            v-for="(item, index) in existPhone.repet_phone"
            :key="index"
            >{{ item }}
          </span>
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button size="mini" @click="HandleDialogVisibleClose3">关 闭</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import img1 from "../../assets/image/qingtong.png";
import img2 from "../../assets/image/baiyin.png";
import img3 from "../../assets/image/huangjin.png";
import img4 from "../../assets/image/bojin.png";
import img5 from "../../assets/image/zuanshi.png";
import img6 from "../../assets/image/wangzhe.png";
export default {
  name: "TycCluePoolTM",
  props: {
    user: Object,
  },
  data() {
    return {
      activeOpen: "",
      customerSource: [],
      dialogVisible: false,
      dialogVisible2: false,
      dialogVisible3: false,
      uploadStatus: false,
      multipleSelection: [],
      clues_type: "",
      switchValue: false,
      count: "",
      allotData: {
        uid: "",
        ids: [],
        username: "",
        status: [],
      },
      uploadHeader: { Authorization: localStorage.token },
      search: "",
      refer_cate: "",
      searchData: {},
      inputSize: "small",
      vipData: {},
      vipName: "",
      vipNum: 0,
      closeShow: false,
      value1: [],
      value: [3, 37],
      value2: [1, 2, 3, 4],
      value3: [3, 37],
      pageNodes: [],
      serverTypes: [],
      changHeightClass: "",
      highSearch: {
        group_chat_id: "",
        im_name: "",
        refer_cate: "",
        start_time: "",
        end_time: "",
        garden: "",
        communicat_at: [],
        communicat_times: null,
      },
      optionProps: {
        value: "id",
        label: "Provincial",
        children: "son",
      },
      textareaSize: { minRows: 6, maxRows: 10 },
      options: [],
      options2: [
        {
          value: 1,
          label: "IM套电",
        },
        {
          value: 2,
          label: "下单未支付",
        },
        {
          value: 3,
          label: "仅点快捷回复",
        },
        {
          value: 4,
          label: "仅IM咨询",
        },
      ],
      options3: [
        {
          value: 1,
          label: "云上注册",
        },
        {
          value: 2,
          label: "非云上注册",
        },
        {
          value: 3,
          label: "代理记账",
        },
        {
          value: 4,
          label: "公司注销",
        },
        {
          value: 5,
          label: "企业资质",
        },
        {
          value: 6,
          label: "公司变更",
        },
      ],
      options4: [
        {
          value: 1,
          label: "上海园区",
        },
        {
          value: 2,
          label: "南京园区",
        },
        {
          value: 3,
          label: "徐州园区",
        },
        {
          value: 6,
          label: "北京园区",
        },
        {
          value: 7,
          label: "天津园区",
        },
        {
          value: 8,
          label: "江苏园区",
        },
        {
          value: 9,
          label: "浙江园区",
        },
        {
          value: 10,
          label: "广东园区",
        },
        {
          value: 11,
          label: "江西园区",
        },
        {
          value: 12,
          label: "山东园区",
        },
        {
          value: 13,
          label: "山西园区",
        },
        {
          value: 14,
          label: "河南园区",
        },
        {
          value: 15,
          label: "河北园区",
        },
        {
          value: 16,
          label: "湖南园区",
        },
        {
          value: 17,
          label: "湖北园区",
        },
        {
          value: 18,
          label: "贵州园区",
        },
        {
          value: 19,
          label: "陕西园区",
        },
        {
          value: 20,
          label: "四川园区",
        },
        {
          value: 21,
          label: "安徽园区",
        },
      ],
      vipIcon: "",
      img: "",
      CluesPool: [],
      pageOption: {
        total: 0,
        currentPage: 1, // 当前页数
        pageSize: 10, // 每页显示条数
      },
      addDrawer: false,
      addForm: {
        customer_source: "",
        garden: 1,
        status: 1,
        custom_name: "",
        custom_phone: "",
        wechat_account: "",
        custom_province: "",
        custom_city: "",
        custom_city_name: "",
        group_chat_id: "",
        page_title: "",
        im_name: "",
        refer_cate: 1,
        refer_content: "",
        conversion_people: "",
        uid: "",
        type: 0,
      },
      col: [
        {
          label: "页面标题",
          prop: "page_title",
          display: false,
        },
        {
          label: "IM人员",
          prop: "im_name",
          display: false,
        },
        {
          label: "园区",
          prop: "garden",
          display: false,
        },
      ],
      ConversionPeople: [],
      activeNames: ["1"],
      loading: [],
      values: "",
      startTime: "",
      endTime: "",
      custom_city_name: "上海市/上海市",
      dialogVisible4: false,
      existPhone: {},
      existPhoneCount: 0,
      pickerOptions: {
        shortcuts: [
          {
            text: "今天",
            onClick: (picker) => {
              picker.$emit("pick", [new Date(), new Date()]);
            },
          },
          {
            text: "昨天",
            onClick: (picker) => {
              const date = new Date();
              date.setTime(date.getTime() - 3600 * 1000 * 24);
              picker.$emit("pick", [date, date]);
            },
          },
          {
            text: "本周",
            onClick: (picker) => {
              picker.$emit("pick", [this.thisWeek()[0], this.thisWeek()[1]]);
            },
          },
          {
            text: "上周",
            onClick: (picker) => {
              picker.$emit("pick", [this.LastWeek()[0], this.LastWeek()[1]]);
            },
          },
          {
            text: "本月",
            onClick: (picker) => {
              picker.$emit("pick", [this.thisMonth()[0], this.thisMonth()[1]]);
            },
          },
          {
            text: "上个月",
            onClick: (picker) => {
              picker.$emit("pick", [this.LastMonth()[0], this.LastMonth()[1]]);
            },
          },
        ],
      },
      pickerOptionsExport: {
        shortcuts: [
          {
            text: "今天",
            onClick: (picker) => {
              picker.$emit("pick", [new Date(), new Date()]);
            },
          },
          {
            text: "昨天",
            onClick: (picker) => {
              const date = new Date();
              date.setTime(date.getTime() - 3600 * 1000 * 24);
              picker.$emit("pick", [date, date]);
            },
          },
          {
            text: "本周",
            onClick: (picker) => {
              picker.$emit("pick", [this.thisWeek()[0], this.thisWeek()[1]]);
            },
          },
          {
            text: "上周",
            onClick: (picker) => {
              picker.$emit("pick", [this.LastWeek()[0], this.LastWeek()[1]]);
            },
          },
          {
            text: "本月",
            onClick: (picker) => {
              picker.$emit("pick", [this.thisMonth()[0], this.thisMonth()[1]]);
            },
          },
          {
            text: "上个月",
            onClick: (picker) => {
              picker.$emit("pick", [this.LastMonth()[0], this.LastMonth()[1]]);
            },
          },
        ],
      },
    };
  },
  computed: {
    pageData: function () {
      return this.CluesPool.filter(
        (data) =>
          !this.search ||
          (data.wechat_account &&
            data.wechat_account.toLowerCase().includes(this.search.toLowerCase())) ||
          (data.custom_phone &&
            data.custom_phone.toLowerCase().includes(this.search.toLowerCase()))
      ).slice(
        this.pageOption.pageSize * (this.pageOption.currentPage - 1),
        this.pageOption.pageSize * this.pageOption.currentPage
      );
    },
    actionHost: {
      get: function () {
        return process.env.NODE_ENV === "development" ? "" : "https://weixin.qiyehuo.com";
      },
    },
    collapse() {
      return this.$store.state.collapse;
    },
  },
  watch: {
    search: function () {
      this.pageOption.total = this.search ? this.searchTotal() : this.CluesPool.length;
    },
  },
  methods: {
    getDetail(val) {
      this.search = val;
      setTimeout(() => {
        this.handelGetOrders();
      }, 20);
    },
    downloadHandleImport() {
      this.$axios
        .post("/api/tm_thread/template", {}, { responseType: "blob" })
        .then((res) => {
          if (res.status === 205) {
            return;
          }
          let blob = new Blob([res.data], {
            type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
          });
          let objectUrl = window.URL.createObjectURL(blob);
          let link = document.createElement("a");
          link.href = objectUrl;
          link.download = "线索导入模板.xlsx";
          link.click();
          setTimeout(function () {
            window.URL.revokeObjectURL(objectUrl);
          }, 100);
          // window.location.href = objectUrl
        });
    },
    communicatTimes(val) {
      this.highSearch.communicat_times = val.replace(/[^\d.]/g, "");
      // this.highSearch.communicat_times = val
    },
    searchTotal() {
      return this.CluesPool.filter(
        (data) =>
          !this.search ||
          (data.custom_phone &&
            data.custom_phone.toLowerCase().includes(this.search.toLowerCase())) ||
          (data.wechat_account &&
            data.wechat_account.toLowerCase().includes(this.search.toLowerCase()))
      ).length;
    },
    copyUrl(data) {
      let url = data;
      let oInput = document.createElement("input");
      oInput.value = url;
      document.body.appendChild(oInput);
      oInput.select(); // 选择对象;
      // console.log(oInput.value)
      document.execCommand("Copy"); // 执行浏览器复制命令
      this.$message({
        message: "已成功复制到剪切板",
        type: "success",
      });
      oInput.remove();
    },
    tableColumn(prop) {
      let width = "";
      if (prop === "page_title") {
        width = 140;
      }
      return width;
    },
    HandleDialogVisible2() {
      if (!this.clues_type) {
        this.$message.error("请先选择线索类型");
      }
    },
    selectCluesType(value) {
      let a = true;
      this.uploadStatus = value ? a : false;
    },
    HandleDialogVisibleClose2() {
      this.dialogVisible3 = false;
      this.uploadStatus = false;
      this.clues_type = "";
    },
    HandleDialogVisibleClose3() {
      this.dialogVisible4 = false;
      this.existPhone = {};
    },
    switchChange(value) {
      this.addForm.uid = value ? this.addForm.uid : "";
      this.addForm.type = value ? 1 : 0;
    },
    selectExport(val) {
      console.log(val);
    },
    selectType(val) {
      console.log(val);
    },
    pickerDataChange2(val) {
      if (!val) {
        this.startTime = "";
        this.endTime = "";
      } else {
        this.startTime = val[0];
        this.endTime = val[1];
      }
    },
    handleExport() {
      this.$axios
        .post(
          "/api/tm_thread/excelout",
          {
            params: {
              start_time: this.startTime,
              end_time: this.endTime,
              input_types: this.value2,
            },
          },
          { responseType: "blob" }
        )
        .then((res) => {
          if (res.status === 205) {
            return;
          }
          let blob = new Blob([res.data], {
            type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
          });
          let objectUrl = window.URL.createObjectURL(blob);
          let link = document.createElement("a");
          link.href = objectUrl;
          link.download = "线索.xlsx";
          link.click();
          setTimeout(function () {
            window.URL.revokeObjectURL(objectUrl);
          }, 100);
          // window.location.href = objectUrl
        });
    },
    handleSelectionChange(val) {
      this.multipleSelection = val;
    },
    handleAddAllot() {
      if (this.multipleSelection.length) {
        this.dialogVisible2 = true;
        for (var a = 0; a < this.multipleSelection.length; a++) {
          this.allotData.ids[a] = this.multipleSelection[a].thread_id;
          this.allotData.status[a] = this.multipleSelection[a].status;
        }
      } else {
        this.$message.error("请先选择要分配的线索");
      }
    },
    HandleDialogVisible() {
      if (!this.allotData.uid) {
        this.$message.error("请选择分配人");
        return;
      }
      this.ConversionPeople.forEach((item) => {
        if (item.id === this.allotData.uid) {
          this.allotData.username = item.username;
        }
      });
      this.$axios
        .post("/api/tm_thread/get_batch_thread", {
          params: {
            uid: this.allotData.uid,
            ids: this.allotData.ids,
            username: this.allotData.username,
            status: this.allotData.status,
          },
        })
        .then((res) => {
          const { data } = res;
          if (data.code === 0) {
            this.$message.success(data.msg);
            this.handelGetOrders();
            this.dialogVisible2 = false;
            if (this.index === 0) this.prePage();
          } else {
            this.$message.error(data.msg);
          }
        });
    },
    HandleDialogVisibleClose() {
      this.dialogVisible2 = false;
    },
    groupInput(val) {
      this.highSearch.group_chat_id = val;
    },
    handleSearch() {
      this.pageOption.currentPage = 1;
      this.activeOpen = '';
      this.handelGetOrders(
        this.highSearch.group_chat_id,
        this.highSearch.im_name,
        this.highSearch.refer_cate,
        this.highSearch.start_time,
        this.highSearch.end_time,
        this.highSearch.garden,
        this.highSearch.communicat_at,
        this.highSearch.communicat_times
      );
    },
    handleCloseSearch() {
      this.highSearch.group_chat_id = "";
      this.highSearch.im_name = "";
      this.highSearch.refer_cate = "";
      this.highSearch.garden = "";
      this.highSearch.communicat_at = [];
      this.highSearch.communicat_times = null;
      this.value1 = [];
      this.activeOpen = '';
      this.handelGetOrders(
        this.highSearch.group_chat_id,
        this.highSearch.im_name,
        this.highSearch.refer_cate,
        this.value1,
        this.value1,
        this.highSearch.garden,
        this.highSearch.communicat_at,
        this.highSearch.communicat_times
      );
    },
    handleChangeHeight(val) {},
    getVipCluesNum() {
      this.$axios.get("/api/tm_thread/statistics").then((res) => {
        const { data } = res;
        if (data.code === 0) {
          this.vipData = data.data;
          this.vipName = this.vipGradeMethods(data.data.level);
          this.img = this.vipGradeIconMethods(data.data.level);
        }
      });
    },
    vipGradeIconMethods(key) {
      let vipData = [" ", img1, img2, img3, img4, img5, img6];
      return vipData[key];
    },
    vipGradeMethods(key) {
      let vipData = [" ", "青铜", "白银", "黄金", "铂金", "钻石", "最强王者"];
      return vipData[key];
    },
    gardenMethods(key) {
      let vipData = [" ", "上海园区", "南京园区", "徐州园区"];
      return vipData[key];
    },
    handelGetOrders(
      groupChatId,
      imName,
      referCate,
      startTime,
      endTime,
      Garden,
      communicatAt,
      communicatTimes
    ) {
      this.$axios
        .get(
          "/api/tm_thread/show?page=" +
            this.pageOption.currentPage +
            "&perPage=" +
            this.pageOption.pageSize,
          {
            params: {
              group_chat_id: groupChatId,
              im_name: imName,
              refer_cate: referCate,
              start_time: startTime,
              end_time: endTime,
              garden: Garden,
              communicat_at: communicatAt,
              communicat_times: communicatTimes,
              search: this.search,
            },
          }
        )
        .then((res) => {
          const { data } = res;
          if (data.code === 0) {
            // this.CluesPool = data.data.list
            this.CluesPool = data.data.list.data;
            this.serverTypes = data.data.serverTypes;
            this.pageNodes = data.data.pageNodes;
            this.count = data.data.count;
            this.ConversionPeople = data.data.users;
            this.customerSource = data.data.customer_source;
            for (var a = 0; a < this.CluesPool.length; a++) {
              this.CluesPool[a].refer_cate = this.refer_cateMethods(
                this.CluesPool[a].refer_cate
              );
              this.CluesPool[a].garden = this.gardenMethods(this.CluesPool[a].garden);
              this.CluesPool[a].customer_city = this.CluesPool[a].custom_city_name;
              if (this.CluesPool[a].custom_phone) {
                this.CluesPool[a].custom_phone2 = "*******";
              }
              if (this.CluesPool[a].wechat_account) {
                this.CluesPool[a].wechat_account2 = "*******";
              }
            }
            this.pageOption.total = data.data.count;
          }
        });
    },
    provinceCityData() {
      this.$axios.get("/api/tm_thread/cities").then((res) => {
        const { data } = res;
        if (data.code === 0) {
          for (var a = 0; a < data.data.length; a++) {
            this.options.push(data.data[a]);
          }
        }
      });
    },
    refer_cateMethods(key) {
      let vipData = [
        " ",
        "云上注册",
        "非云上注册",
        "代理记账",
        "公司注销",
        "企业资质",
        "公司变更",
      ];
      return vipData[key];
    },
    pickerDataChange(val) {
      if (!val) {
        this.highSearch.start_time = "";
        this.highSearch.end_time = "";
      } else {
        this.highSearch.start_time = val[0];
        this.highSearch.end_time = val[1];
      }
    },
    pickerDataChangeRecently(val) {
      if (!val) {
        this.highSearch.communicat_at = [];
      } else {
        this.highSearch.communicat_at[0] = val[0];
        this.highSearch.communicat_at[1] = val[1];
      }
    },
    handleSizeChange(val) {
      this.pageOption.pageSize = val;
      this.handelGetOrders();
    },
    handleCurrentChange(val) {
      this.pageOption.currentPage = val;
      this.handelGetOrders();
    },
    handelSetValue() {
      for (var i = 0; i <= this.col.length; i++) {
        this.value1.push(i);
      }
    },
    handleChangeSearch(value) {
      let input = this.$refs["cascaderAddr"].getCheckedNodes()[0].pathLabels;
      this.highSearch.custom_city_name = input[0] + "/" + input[1];
    },
    handleChange(value) {
      let input = this.$refs["cascaderAddr"].getCheckedNodes()[0].pathLabels;
      this.addForm.custom_city_name = input[0] + "/" + input[1];
      this.custom_city_name = input[0] + "/" + input[1];
      this.addForm.custom_province = value[0];
      this.addForm.custom_city = value[1];
    },
    handleAddOpen() {
      let that = this;
      that.addDrawer = true;
      that.addForm.custom_city_name = that.custom_city_name;
      that.addForm.custom_province = that.value[0];
      that.addForm.custom_city = that.value[1];
      that.addForm.refer_cate = 1;
    },
    selectStatus(val) {
      if (val === 4) {
        for (var a = 0; a < this.ConversionPeople.length; a++) {
          if (this.ConversionPeople[a].id === this.user.id) {
            this.addForm.uid = this.ConversionPeople[a].id;
          }
        }
      } else {
        this.addForm.uid = "";
      }
    },
    handleAddDrawerBeforeClose(done) {
      this.$confirm("确认关闭?")
        .then((_) => {
          this.clearAddData();
          done();
        })
        .catch((_) => {});
    },
    handleAddDrawerClose() {
      this.addDrawer = false;
      this.clearAddData();
    },
    clearAddData() {
      this.addForm.status = 1;
      this.addForm.custom_name = "";
      this.addForm.custom_phone = "";
      this.addForm.wechat_account = "";
      this.addForm.im_name = "";
      this.addForm.page_title = "";
      this.addForm.group_chat_id = "";
      this.addForm.refer_cate = "";
      this.addForm.refer_content = "";
      this.addForm.uid = "";
      this.switchValue = false;
      this.addForm.type = 0;
    },
    handleSave() {
      let phone = /^1[3|4|5|7|6|8|9][0-9]{9}$/;
      if (!this.addForm.custom_phone && !this.addForm.wechat_account) {
        this.$message.error("客户手机或微信号不能为空");
        return;
      }
      if (this.addForm.custom_phone !== "") {
        if (!phone.test(this.addForm.custom_phone)) {
          this.$message.error("客户手机号格式不正确");
          return;
        }
      }
      if (!this.addForm.custom_province) {
        this.$message.error("请选择所属省市");
        return;
      }
      if (!this.addForm.group_chat_id) {
        this.$message.error("群聊ID不能为空");
        return;
      }
      if (this.addForm.status === 2) {
        if (!this.addForm.uid) {
          this.$message.error("转化人不能为空");
          return;
        }
      }
      if (!this.addForm.refer_cate) {
        this.$message.error("请选择咨询分类");
        return;
      }
      if (!this.addForm.refer_content) {
        this.$message.error("咨询关键内容不能为空");
        return;
      }
      let that = this;
      this.$axios.post("/api/tm_thread/imcreate", that.addForm).then((res) => {
        const { data } = res;
        if (data.code === 0) {
          if (!that.addForm.uid) {
            data.data[0].refer_cate = that.refer_cateMethods(data.data[0].refer_cate);
            data.data[0].garden = that.gardenMethods(data.data[0].garden);
            that.CluesPool.unshift(data.data[0]);
            that.CluesPool[0].customer_city = data.data[0].custom_city_name;
            that.custom_city_name = that.addForm.custom_city_name;
          }
          that.getVipCluesNum();
          that.pageOption.total = that.pageOption.total + data.data.length;
          that.handleAddDrawerClose();
          that.$message.success(data.msg);
        } else {
          that.$message.error(data.msg);
        }
      });
    },
    handleEditOpen(index, id) {
      this.getClues(index, id);
    },
    getClues(index, id) {
      this.$axios.get("/api/tm_thread/getthread/" + id).then((res) => {
        const { data } = res;
        if (data.code === 0) {
          let idx = this.pageOption.pageSize * (this.pageOption.currentPage - 1) + index;
          this.CluesPool.splice(idx, 1);
          this.pageOption.total = this.CluesPool.length;
          this.getVipCluesNum();
          this.$notify({
            title: "成功",
            message: "线索领取成功",
            type: "success",
          });
          if (index === 0) this.prePage();
        } else if (data.code === 1001) {
          this.$message.error(data.msg);
          this.handelGetOrders();
        } else {
          this.$message.error(data.msg);
        }
      });
    },
    prePage() {
      if (this.pageOption.currentPage === 1) return;
      this.pageOption.currentPage = this.pageOption.currentPage - 1;
    },
    handleUpdateClose(done) {
      this.$confirm("确认关闭?")
        .then((_) => {
          this.clearUpdateData();
          done();
        })
        .catch((_) => {});
    },
    handleImport(res, file) {
      if (res.code === 0) {
        this.handelGetOrders();
        this.$message.success(res.msg);
        this.loading.close();
        this.dialogVisible3 = false;
        this.uploadStatus = false;
        this.clues_type = "";
        this.dialogVisible4 = true;
        this.existPhone = res.data;
        this.existPhoneCount = res.data.repet_phone.length;
      }
    },
    beforeAvatarUpload() {
      this.loading = this.$loading({
        lock: true,
        text: "加载中",
        background: "rgba(0, 0, 0, 0.7)",
      });
    },
    LastWeek() {
      const end = new Date();
      const start = new Date();
      const lastWeek = new Date().getDay(); // 获取今日周几
      // 开始时间(上周一与今天间隔的天数)
      start.setTime(start.getTime() - 3600 * 1000 * 24 * (7 + lastWeek - 1)); // 减1是因为以下时间戳操作,例如周二,但是时间戳还在周一后的xx小时
      // 结束时间(上周末与今天间隔的天数)
      end.setTime(end.getTime() - 3600 * 1000 * 24 * lastWeek);
      return [start, end];
    },
    thisWeek() {
      var Nowdate = new Date();
      var WeekFirstDay = new Date(Nowdate - (Nowdate.getDay() - 1) * 86400000);

      var M = Number(WeekFirstDay.getMonth()) + 1;
      var start = WeekFirstDay.getFullYear() + "-" + M + "-" + WeekFirstDay.getDate();

      var WeekLastDay = new Date((WeekFirstDay / 1000 + 6 * 86400) * 1000);
      var Mon = Number(WeekLastDay.getMonth()) + 1;
      var end = WeekLastDay.getFullYear() + "-" + Mon + "-" + WeekLastDay.getDate();

      return [start, end];
    },
    thisMonth() {
      const end = new Date();
      const start = new Date();
      // 方法1
      const endDay = new Date().getDate() - 1; // 获取今日几号,减1是因为以下时间戳操作,例如今日16号,但是时间戳还在15号后的xx小时
      start.setTime(start.getTime() - 3600 * 1000 * 24 * endDay);
      // 方法2
      // start.setDate(1) //setDate(1)表示设置开始时间为本月1号,此办法同样可以实现
      return [start, end];
    },
    LastMonth() {
      const end = new Date();
      const start = new Date();
      const year = new Date().getFullYear(); // 获取年份
      let month = new Date().getMonth(); // 获取月份
      month = month === 0 ? 1 : month; // 特殊处理:如果为1月 则下方取1月的天数
      const febDays = year % 4 ? 29 : 28; // 判断今年是否为闰年,如是则二月天数为29天,反之为28天
      let days = [31, febDays, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31]; // 罗列12个月的天数
      start.setDate(1 - days[month - 1]); // setDate(1)表表示设置为本月1号,故 本月1号 - 上月天数 = 上月1号
      end.setDate(1 - 1); // 以此得出,本月1号 - 1天 = 上月最后一天
      return [start, end];
    },
    handleClickCollapseOutSide(event) {
      const elCollapse = this.$el.querySelector('.el-collapse');
      if (elCollapse && !elCollapse.contains(event.target)) {
        this.activeOpen = '';
      }
    },
  },
  beforeDestroy() {
    document.removeEventListener('click', this.handleClickCollapseOutSide);
  },
  mounted() {
    this.provinceCityData();
    this.handelGetOrders();
    this.getVipCluesNum();
    document.addEventListener('click', this.handleClickCollapseOutSide);
  },
};
</script>

<style lang="stylus" scoped>
  @import '~styles/varibles.styl'
  @import '~styles/vertical.styl'
  @import '~styles/icon.styl'
  .el-date-editor
    width: 100% !important
  .el-drawer__wrapper >>> .el-drawer
    overflow-y: auto
  .el-drawer__wrapper >>> .el-drawer__header span
    color: #4c87fc
    font-size 0.36rem
    font-weight 400
  .clue-pool
    marginLeft()
    .count_style
      display: inline-block
      overflow: hidden
      text-overflow: ellipsis
      white-space: nowrap
    .icon-qingtonghuiyuan
      color: #E9935D;
    .icon-baiyinhuiyuan
      color: #E6E8FA
    .icon-huangjinhuiyuan
      color: #FFD32F;
    .icon-qingtong
      color: #40BBEC
    .icon-zuanshi
      color: #83A4FF;
    .icon-wangzhe
      color: #A8A8A8
  .mb-10
    margin-bottom: .2rem
    margin-top .4rem
  .mt-10
    margin-top: .2rem
  .level
    display flex
    align-items center
    position relative
    padding-right .32rem
    img
      width .32rem
      height .30rem
    .el-icon-question
      margin-left: .1rem
      color: #409EFF
      position absolute
      top 0
      right 0
      cursor pointer
  .count
    padding-left: .2rem
    line-height: .56rem
  .tr
    text-align: right
  .m-tabs-content
    padding: 0 .2rem 0 .4rem
    .tabs_line
      display flex
      .lines
        width .06rem
        height .30rem
        background #4C87FC
        margin-right .1rem
      .tabs-title
        color: #000000
        font-weight bold
    .m-label
      line-height: .56rem
    .text_right
      text-align left
    .el-row
      margin-bottom: .4rem
    .el-date-editor.el-input, .el-date-editor.el-input__inner
      width: 100%
    .el-select
      width: 100%
  .changeHeight
    padding 0
    margin-top .4rem
  .clue-pool >>> .el-table__header th
    color: #333333
    background-color: #ECF4FF
  .bottom-btn
    padding: .2rem
    text-align: right
.el-position
  position relative
.dot
  display inline-block
  width 0.1rem
  height 0.1rem
  border-radius 50%
  margin-right 0.1rem
  position absolute
  top 0
  left -.2rem
  bottom 0
  margin auto
.el-collapse
  border-bottom 0
  border-top 0
.el-collapse >>> .el-collapse-item__header
  color: #4C87FC
  font-weight bold
.el-collapse >>> .el-collapse-item__arrow
  color: #4C87FC
.el-collapse >>> .el-collapse-item__content
  padding-bottom 0
.el_dialogs >>> .el-dialog__body
  padding-left 0
  padding-right 0
.el_dialogs >>> .el-dialog__header
  padding 0
.box_title
  margin-bottom .4rem
  padding-left .6rem
  span
    font-size 0.32rem
    color: #333
    font-weight bold
.dialog_box
  padding-left 1.45rem
  padding-right 1.45rem
  .box_p
    font-size .28rem
    line-height .7rem
    color: #666666
  img
    width 100%
    margin-top .4rem
.contents
  margin-bottom .4rem
  .dialog-footer
    display block
    position: absolute;
    right .4rem
    bottom .2rem
.export_clues
  margin-bottom .4rem
.hint
  margin-bottom  .4rem
  font-weight bold
.show_phone
  flex-direction column
  overflow-y auto
  max-height 4rem
  .existPhone
    flex-direction row
    justify-content space-between
    box-sizing border-box
    width 100%
    padding-right .1rem
.phone_span
  width 50%
  display inline-block
  margin-bottom 0.3rem
.phone_span:nth-child(2n)
  text-align right
/*滚动条整体样式*/
::-webkit-scrollbar{
  width: .1rem;/*竖向滚动条的宽度*/
  height: 10px;/*横向滚动条的高度*/
}
::-webkit-scrollbar-thumb{/*滚动条里面的小方块*/
  background: #cdcdcd;
  border-radius: 5px;
}
::-webkit-scrollbar-track{/*滚动条轨道的样式*/
  background: #f8f8f8;
  border-radius: 5px;
}
</style>



// WEBPACK FOOTER //
// src/pages/tyc_clue_pool/TycCluePoolTM.vue